import { render, staticRenderFns } from "./DraftPindahBarang.vue?vue&type=template&id=255074c2&"
import script from "./DraftPindahBarang.vue?vue&type=script&lang=js&"
export * from "./DraftPindahBarang.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports